export default __webpack_public_path__ + "static/media/onTree.d042ce89.webp";